// DeleteMultiModal.js
import React from "react";

const DeleteMultiModal = ({ title, isOpen, onClose, onDelete, count }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "24px",
                    width: "400px",
                    maxWidth: "90%",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}
            >
                <div
                    style={{
                        fontSize: "20px",
                        fontWeight: 700,
                        color: "#1E1E1E",
                        textAlign: "center",
                    }}
                >
                    Delete {title}
                </div>
                <div
                    style={{
                        marginTop: "12px",
                        fontSize: "16px",
                        fontWeight: 400,
                        color: "#1E1E1E",
                        textAlign: "center",
                    }}
                >
                    You won’t be able to access your {title} after deleting. Are you
                    sure you want to delete?
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "16px",
                        marginTop: "24px",
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            flex: 1,
                            height: "44px",
                            borderRadius: "8px",
                            border: "1px solid #E5E5E5",
                            background: "#fff",
                            fontSize: "16px",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            cursor: "pointer",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onDelete}
                        style={{
                            flex: 1,
                            height: "44px",
                            borderRadius: "8px",
                            background: "#FF4444",
                            fontSize: "16px",
                            fontWeight: 500,
                            color: "#fff",
                            cursor: "pointer",
                        }}
                    >
                        Delete {count > 0 ? `(${count})` : ""}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteMultiModal;
